import $ from 'jquery'
import  naviero from '../img/reporte.png';
import  facturacion from '../img/facturacion.png';
import  ventas from '../img/ventas.png';
import  almacen2 from '../img/almacen2.png';
import  reporte from '../img/reporte.png';

$(document).ready(function () {
    // fila uno

    $('#naviero-personalizados').click(function (e) { 
        $('#titulo-personalizado').text('SISTEMA NAVIERO');
        $('#texto-personalizado').html("Sistema alineado a las agencias de carga. Este modulo opera desde la cotización de la línea,pasando por la cotización al cliente, <br/> llevando un seguimiento de la carga, luego manejando la operación de la carga con avisos de llegada,avisos de embarque, etc.");
        $("#imagen-personalizado").attr('src', naviero);
    });
    $('#naviero').click(function (e) { 
        $('#titulo-personalizado').text('SISTEMA NAVIERO');
        $('#texto-personalizado').html("Sistema alineado a las agencias de carga. Este modulo opera desde la cotización de la línea,pasando por la cotización al cliente, <br/> llevando un seguimiento de la carga, luego manejando la operación de la carga con avisos de llegada,avisos de embarque, etc.");
        $("#imagen-personalizado").attr('src', naviero);
    });



    $('#turismo-personalizados').click(function (e) { 
        $('#titulo-personalizado').text('SISTEMA TURISMO RECEPTIVO');
        $('#texto-personalizado').html("Este sistema se inicia desde los costos de los proveedores, pasando por las cotizaciones a los clientes del exterior, cotización que al momento de ser aceptada,<br/> es información que sirve para apertura de un File. Asimismo, se tiene alineada la migración de estos datos al módulo contable donde finaliza la información.");
        $("#imagen-personalizado").attr('src', facturacion);
    });
    $('#turismo').click(function (e) { 
        $('#titulo-personalizado').text('SISTEMA TURISMO RECEPTIVO');
        $('#texto-personalizado').html("Este sistema se inicia desde los costos de los proveedores, pasando por las cotizaciones a los clientes del exterior, cotización que al momento de ser aceptada,<br/> es información que sirve para apertura de un File. Asimismo, se tiene alineada la migración de estos datos al módulo contable donde finaliza la información.");
        $("#imagen-personalizado").attr('src', facturacion);
    });




    $('#tienda-personalizados').click(function (e) { 
        $('#titulo-personalizado').text('SISTEMA DE TIENDA');
        $('#texto-personalizado').html("Sistema de soporte a clientes que poseen tiendas comerciales. Aquí se usa mucho las transferencias de fabrica a tiendas a través <br/> de interfaces .(sea IP directo, archivos de carga, VPN, etc.). Posee liquidación de caja chica y Reportes de ventas especiales.");
        $("#imagen-personalizado").attr('src', ventas);
    });
    $('#tienda').click(function (e) { 
        $('#titulo-personalizado').text('SISTEMA DE TIENDA');
        $('#texto-personalizado').html("Sistema de soporte a clientes que poseen tiendas comerciales. Aquí se usa mucho las transferencias de fabrica a tiendas a través <br/> de interfaces .(sea IP directo, archivos de carga, VPN, etc.). Posee liquidación de caja chica y Reportes de ventas especiales.");
        $("#imagen-personalizado").attr('src', ventas);
    });



    //fila dos

    $('#textil-personalizados').click(function (e) { 
        $('#titulo-personalizado').text('SISTEMA DE PRODUCCION TEXTIL');
        $('#texto-personalizado').html("Este sistema te permite definir los planes de trabajo mediante diagramas , además de  poder realizar una gestión operativa del almacén en todas las fases <br/>intermedias de la producción textil. De esta forma se puede realizar un control preciso de la producción.");
        $("#imagen-personalizado").attr('src', reporte);
    });
    $('#textil').click(function (e) { 
        $('#titulo-personalizado').text('SISTEMA DE PRODUCCION TEXTIL');
        $('#texto-personalizado').html("Este sistema te permite definir los planes de trabajo mediante diagramas , además de  poder realizar una gestión operativa del almacén en todas las fases <br/>intermedias de la producción textil. De esta forma se puede realizar un control preciso de la producción.");
        $("#imagen-personalizado").attr('src', reporte);
    });




    $('#transporte-personalizados').click(function (e) { 
        $('#titulo-personalizado').text('SISTEMA DE TRANSPORTE');
        $('#texto-personalizado').html("El software de gestión de transporte  está diseñado para ayudarle a reducir sus costes de transporte, mejorar las tasas de llenado y optimizar la asignación de transportista.<br/> Esta solución integral garantiza una respuesta rápida y fiable, niveles mínimos de existencias y el control total de la gestión de los flujos, etc. ");
        $("#imagen-personalizado").attr('src', ventas);
    });
    $('#transporte').click(function (e) { 
        $('#titulo-personalizado').text('SISTEMA DE TRANSPORTE');
        $('#texto-personalizado').html("El software de gestión de transporte  está diseñado para ayudarle a reducir sus costes de transporte, mejorar las tasas de llenado y optimizar la asignación de transportista.<br/> Esta solución integral garantiza una respuesta rápida y fiable, niveles mínimos de existencias y el control total de la gestión de los flujos, etc. ");
        $("#imagen-personalizado").attr('src', ventas);
    });





    $('#aduana-personalizados').click(function (e) { 
        $('#titulo-personalizado').text('SISTEMA DE AGENCIAS DE ADUANA ');
        $('#texto-personalizado').html("Sistema Integral de aduanas le ofrece diferentes módulos de generación del pedimento de manera eficiente. Este modulo permite realizar diferentes <br/> reportes por cliente, ver el status de una referencia. así cla aceptación o negación del encargo conferido");
        $("#imagen-personalizado").attr('src', facturacion);
    });
    $('#aduana').click(function (e) { 
        $('#titulo-personalizado').text('SISTEMA DE AGENCIAS DE ADUANA ');
        $('#texto-personalizado').html("Sistema Integral de aduanas le ofrece diferentes módulos de generación del pedimento de manera eficiente. Este modulo permite realizar diferentes <br/> reportes por cliente, ver el status de una referencia. así cla aceptación o negación del encargo conferido");
        $("#imagen-personalizado").attr('src', facturacion);
    });

});




// WEBPACK FOOTER //
// ./src/js/EventoPersonalizados.js